import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polygon, { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15.54 8.46a5 5 0 0 1 0 7.07", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Volume1";
const Volume1 = memo(themed(Icon));
export {
  Volume1
};
//# sourceMappingURL=volume-1.js.map
